import { Reveal, Eyebrow } from "../components/Reveal";

const CREDENTIALS = ["MBBS", "DMRD", "FMF UK Certified", "Certified Functional Medicine Practitioner"];

export const Doctor = () => (
  <section id="about" className="bg-paper grain relative" data-testid="doctor-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-20 lg:py-32 grid grid-cols-1 lg:grid-cols-12 gap-14 items-start">
      <div className="lg:col-span-5">
        <Reveal>
          <div className="relative">
            <div className="absolute -inset-3 border border-gold/50 pointer-events-none" aria-hidden="true" />
            <img
              src="/assets/dr-rohan-dikshit.jpg"
              alt="Dr Rohan Dikshit — Founder, InSight Metabolics"
              className="relative w-full aspect-[4/5] object-cover object-top"
              loading="lazy"
              data-testid="doctor-photo"
            />
          </div>
        </Reveal>
      </div>
      <div className="lg:col-span-7">
        <Reveal>
          <Eyebrow>04 · About the doctor</Eyebrow>
          <h2 className="mt-6 font-serif font-medium text-forest text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight max-w-xl">
            Medicine, with more time to understand the person.
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-8 font-serif text-3xl text-ink">Dr Rohan Dikshit</p>
          <div className="mt-4 flex flex-wrap gap-2.5">
            {CREDENTIALS.map((c) => (
              <span
                key={c}
                className="font-mono text-[10px] tracking-[0.18em] uppercase text-forest border border-forest/25 bg-white px-3.5 py-1.5"
              >
                {c}
              </span>
            ))}
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          {/* Editable: doctor's biography */}
          <div className="mt-8 space-y-5 text-inkmuted leading-relaxed max-w-2xl">
            <p className="font-serif italic text-xl text-forest/90 leading-relaxed">
              &ldquo;InSight Metabolics was created from a simple belief: good medicine begins with listening
              carefully.&rdquo;
            </p>
            <p>
              The purpose of the consultation is not simply to collect laboratory values or prescribe a protocol.
              It is to understand the person, identify what matters most, and build a plan that can work within
              real life.
            </p>
          </div>

          <div className="mt-10 border-t border-line pt-10 space-y-5 text-inkmuted leading-relaxed max-w-2xl">
            <h3 className="font-serif text-2xl sm:text-3xl text-forest leading-snug">
              When treating the disease isn&rsquo;t enough.
            </h3>
            <p>
              For over a decade as a radiologist, I have seen the human body from a different
              perspective&mdash;through its images, patterns and changes over time.
            </p>
            <p>And I began to notice something deeply important.</p>
            <p>
              Many patients were receiving the right diagnosis and the right treatment, yet they continued to
              live with recurring symptoms, metabolic problems and chronic disease. We were often treating what
              had already happened&mdash;but not always asking{" "}
              <strong className="text-ink font-semibold">why it happened in the first place.</strong>
            </p>
            <p>I felt there was a gap that needed to be bridged.</p>
            <p>
              <strong className="text-ink font-semibold">InSight Metabolics was created to bridge that gap.</strong>
            </p>
            <p>
              We combine the precision of modern medicine with a functional, systems-based approach to
              health&mdash;looking beyond isolated symptoms to understand the interconnected influence of
              nutrition, metabolism, gut health, sleep, stress, lifestyle and other potential drivers of disease.
            </p>
            <p>
              The aim is simple:{" "}
              <strong className="text-ink font-semibold">
                to help you understand your health more deeply, identify what may be driving your problems, and
                create a personalised path towards lasting change.
              </strong>
            </p>
            <p>Because chronic disease shouldn&rsquo;t just be managed.</p>
            <p className="font-serif italic text-xl text-gold">
              Your health deserves to be understood.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
